import axios from "axios";

export const sm_gridDataAPI = async (client_id, formattedDate, timeInterval) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/get-smart-meter-grid/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: client_id,
        date: formattedDate,
        interval: timeInterval
      }
    });
    return response;
  } catch (error) {
    // Log the error and return null to indicate failure in fetching data
    console.error('Error fetching site details:', error);
    return null;
  }
};

export const sm_solarDataAPI = async (client_id, formattedDate, timeInterval) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/get-smart-meter-solar/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: client_id,
        date: formattedDate,
        interval: timeInterval
      }
    });
    return response; // Return response to handle it in the component
  } catch (error) {
    return null;
  }
};

export const sm_othersDataAPI = async (client_id, formattedDate, timeInterval) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/get-smart-meter-others/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: client_id,
        date: formattedDate,
        interval: timeInterval
      }
    });
    return response; // Return response to handle it in the component
  } catch (error) {
    return null;
  }
};

export const sm_loadDataAPI = async (client_id, formattedDate, timeInterval) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/get-smart-meter-buildingload/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: client_id,
        date: formattedDate,
        interval: timeInterval
      }
    });
    return response; // Return response to handle it in the component
  } catch (error) {
    return null;
  }
};

export const nema_unbalanceGridAPI = async (client_id, formattedDate, timeInterval) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/nema_unbalance_grid/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: client_id,
        date: formattedDate,
        interval: timeInterval
      }
    });
    return response; // Return response to handle it in the component
  } catch (error) {
    return null;
  }
};

export const nema_unbalanceSolarAPI = async (client_id, formattedDate, timeInterval) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/nema_unbalance_solar/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: client_id,
        date: formattedDate,
        interval: timeInterval
      }
    });
    return response; // Return response to handle it in the component
  } catch (error) {
    return null;
  }
};

export const nema_unbalanceOthersAPI = async (client_id, formattedDate, timeInterval) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/nema_unbalance_others/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: client_id,
        date: formattedDate,
        interval: timeInterval
      }
    });
    return response; // Return response to handle it in the component
  } catch (error) {
    return null;
  }
};

export const nema_unbalanceGrid_currentAPI = async (client_id, formattedDate, timeInterval) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/nema_unbalance_grid_current/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: client_id,
        date: formattedDate,
        interval: timeInterval
      }
    });
    return response; // Return response to handle it in the component
  } catch (error) {
    return null;
  }
};

export const nema_unbalanceSolar_currentAPI = async (client_id, formattedDate, timeInterval) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/nema_unbalance_solar_current/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: client_id,
        date: formattedDate,
        interval: timeInterval
      }
    });
    return response; // Return response to handle it in the component
  } catch (error) {
    return null;
  }
};

export const nema_unbalanceOthers_currentAPI = async (client_id, formattedDate, timeInterval) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/nema_unbalance_others_current/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: client_id,
        date: formattedDate,
        interval: timeInterval
      }
    });
    return response; // Return response to handle it in the component
  } catch (error) {
    return null;
  }
};

export const nema_unbalanceGrid_kwAPI = async (client_id, formattedDate, timeInterval) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/nema_unbalance_grid_kw/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: client_id,
        date: formattedDate,
        interval: timeInterval
      }
    });
    return response; // Return response to handle it in the component
  } catch (error) {
    return null;
  }
};

export const nema_unbalanceSolar_kwAPI = async (client_id, formattedDate, timeInterval) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/nema_unbalance_solar_kw/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: client_id,
        date: formattedDate,
        interval: timeInterval
      }
    });
    return response; // Return response to handle it in the component
  } catch (error) {
    return null;
  }
};

export const nema_unbalanceOthers_kwAPI = async (client_id, formattedDate, timeInterval) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/nema_unbalance_others_kw/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: client_id,
        date: formattedDate,
        interval: timeInterval
      }
    });
    return response; // Return response to handle it in the component
  } catch (error) {
    return null;
  }
};

export const sm_gridDatayesterday = async (client_id, formattedDate, timeInterval) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/get-smart-meter-grid-yesterday/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: client_id,
        date: formattedDate,
        interval: timeInterval
      }
    });
    return response;
  } catch (error) {
    // Log the error and return null to indicate failure in fetching data
    console.error('Error fetching site details:', error);
    return null;
  }
};

export const sm_gridDatasamedaylastweek = async (client_id, formattedDate, timeInterval) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/get-smart-meter-grid-samedaylastweek/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: client_id,
        date: formattedDate,
        interval: timeInterval
      }
    });
    return response;
  } catch (error) {
    // Log the error and return null to indicate failure in fetching data
    console.error('Error fetching site details:', error);
    return null;
  }
};

export const sm_gridDatalastweekavg = async (client_id, formattedDate, timeInterval) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/get-smart-meter-grid-lastweekavg/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: client_id,
        date: formattedDate,
        interval: timeInterval
      }
    });
    return response;
  } catch (error) {
    // Log the error and return null to indicate failure in fetching data
    console.error('Error fetching site details:', error);
    return null;
  }
};

export const sm_gridDatalastmonthavg = async (client_id, formattedDate, timeInterval) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/get-smart-meter-grid-lastmonthavg/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: client_id,
        date: formattedDate,
        interval: timeInterval
      }
    });
    return response;
  } catch (error) {
    // Log the error and return null to indicate failure in fetching data
    console.error('Error fetching site details:', error);
    return null;
  }
};

export const sm_gridDatalastyearavg = async (client_id, formattedDate, timeInterval) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/get-smart-meter-grid-lastyearavg/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: client_id,
        date: formattedDate,
        interval: timeInterval
      }
    });
    return response;
  } catch (error) {
    // Log the error and return null to indicate failure in fetching data
    console.error('Error fetching site details:', error);
    return null;
  }
};

// export const accum_max_kw = async (client_id, formattedDate, timeInterval) => {
//   try {
//     const token = sessionStorage.getItem('accessToken');
//     const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/accum-max-kw/`, {
//       headers: { Authorization: `Bearer ${token}` },
//       params: {
//         site_id: client_id,
//         date: formattedDate,
//         interval: timeInterval
//       }
//     });
//     return response;
//   } catch (error) {
//     // Log the error and return null to indicate failure in fetching data
//     console.error('Error fetching site details:', error);
//     return null;
//   }
// };

// export const accum_max_kw_solar = async (client_id, formattedDate, timeInterval) => {
//   try {
//     const token = sessionStorage.getItem('accessToken');
//     const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/accum-max-kw-solar/`, {
//       headers: { Authorization: `Bearer ${token}` },
//       params: {
//         site_id: client_id,
//         date: formattedDate,
//         interval: timeInterval
//       }
//     });
//     return response;
//   } catch (error) {
//     // Log the error and return null to indicate failure in fetching data
//     console.error('Error fetching site details:', error);
//     return null;
//   }
// };

export const accum_max_kw_others = async (client_id, formattedDate, timeInterval) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/accum-max-kw-others/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: client_id,
        date: formattedDate,
        interval: timeInterval
      }
    });
    return response;
  } catch (error) {
    // Log the error and return null to indicate failure in fetching data
    console.error('Error fetching site details:', error);
    return null;
  }
};

export const sm_solarDatayesterday = async (client_id, formattedDate, timeInterval) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/get-smart-meter-solar-yesterday/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: client_id,
        date: formattedDate,
        interval: timeInterval
      }
    });
    return response;
  } catch (error) {
    // Log the error and return null to indicate failure in fetching data
    console.error('Error fetching site details:', error);
    return null;
  }
};

export const sm_solarDatasamedaylastweek = async (client_id, formattedDate, timeInterval) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/get-smart-meter-solar-samedaylastweek/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: client_id,
        date: formattedDate,
        interval: timeInterval
      }
    });
    return response;
  } catch (error) {
    // Log the error and return null to indicate failure in fetching data
    console.error('Error fetching site details:', error);
    return null;
  }
};

export const sm_solarDatalastweekavg = async (client_id, formattedDate, timeInterval) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/get-smart-meter-solar-lastweekavg/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: client_id,
        date: formattedDate,
        interval: timeInterval
      }
    });
    return response;
  } catch (error) {
    // Log the error and return null to indicate failure in fetching data
    console.error('Error fetching site details:', error);
    return null;
  }
};

export const sm_solarDatalastmonthavg = async (client_id, formattedDate, timeInterval) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/get-smart-meter-solar-lastmonthavg/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: client_id,
        date: formattedDate,
        interval: timeInterval
      }
    });
    return response;
  } catch (error) {
    // Log the error and return null to indicate failure in fetching data
    console.error('Error fetching site details:', error);
    return null;
  }
};

export const sm_solarDatalastyearavg = async (client_id, formattedDate, timeInterval) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/get-smart-meter-solar-lastyearavg/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: client_id,
        date: formattedDate,
        interval: timeInterval
      }
    });
    return response;
  } catch (error) {
    // Log the error and return null to indicate failure in fetching data
    console.error('Error fetching site details:', error);
    return null;
  }
};

export const sm_othersDatayesterday = async (client_id, formattedDate, timeInterval) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/get-smart-meter-others-yesterday/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: client_id,
        date: formattedDate,
        interval: timeInterval
      }
    });
    return response;
  } catch (error) {
    // Log the error and return null to indicate failure in fetching data
    console.error('Error fetching site details:', error);
    return null;
  }
};

export const sm_othersDatasamedaylastweek = async (client_id, formattedDate, timeInterval) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/get-smart-meter-others-samedaylastweek/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: client_id,
        date: formattedDate,
        interval: timeInterval
      }
    });
    return response;
  } catch (error) {
    // Log the error and return null to indicate failure in fetching data
    console.error('Error fetching site details:', error);
    return null;
  }
};

export const sm_othersDatalastweekavg = async (client_id, formattedDate, timeInterval) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/get-smart-meter-others-lastweekavg/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: client_id,
        date: formattedDate,
        interval: timeInterval
      }
    });
    return response;
  } catch (error) {
    // Log the error and return null to indicate failure in fetching data
    console.error('Error fetching site details:', error);
    return null;
  }
};

export const sm_othersDatalastmonthavg = async (client_id, formattedDate, timeInterval) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/get-smart-meter-others-lastmonthavg/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: client_id,
        date: formattedDate,
        interval: timeInterval
      }
    });
    return response;
  } catch (error) {
    // Log the error and return null to indicate failure in fetching data
    console.error('Error fetching site details:', error);
    return null;
  }
};

export const sm_othersDatalastyearavg = async (client_id, formattedDate, timeInterval) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/get-smart-meter-others-lastyearavg/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: client_id,
        date: formattedDate,
        interval: timeInterval
      }
    });
    return response;
  } catch (error) {
    // Log the error and return null to indicate failure in fetching data
    console.error('Error fetching site details:', error);
    return null;
  }
};

export const missing_percentage_grid = async (client_id, formattedDate) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/get-missing-percentage-grid/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: client_id,
        date: formattedDate,
      }
    });
    return response; // Return response to handle it in the component
  } catch (err) {
    throw err; // Re-throw the error to be caught in handleSubmit
  }
};

export const missing_percentage_solar = async (client_id, formattedDate) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/get-missing-percentage-solar/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: client_id,
        date: formattedDate,
      }
    });
    return response; // Return response to handle it in the component
  } catch (err) {
    throw err; // Re-throw the error to be caught in handleSubmit
  }
};

export const missing_percentage_others = async (client_id, formattedDate) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/get-missing-percentage-others/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: client_id,
        date: formattedDate,
      }
    });
    return response; // Return response to handle it in the component
  } catch (err) {
    throw err; // Re-throw the error to be caught in handleSubmit
  }
};



export const average_daily_load_curve = async (client_id, formattedDate) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/average-daily-load-curve/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: client_id,
        date: formattedDate,
      }
    });
    return response; // Return response to handle it in the component
  } catch (err) {
    throw err; // Re-throw the error to be caught in handleSubmit
  }
};

export const esg_load_gj = async (client_id, formattedDate) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/esg-load-gj/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: client_id,
        date: formattedDate,
      }
    });
    return response; // Return response to handle it in the component
  } catch (err) {
    throw err; // Re-throw the error to be caught in handleSubmit
  }
};


export const unified_meters_others_max = async (client_id, formattedDate) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/unified-meters-others-max/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: client_id,
        date: formattedDate,
      }
    });
    return response; // Return response to handle it in the component
  } catch (err) {
    throw err; // Re-throw the error to be caught in handleSubmit
  }
};

export const ranked_component_consumption = async (client_id, formattedDate) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/ranked-component-consumption/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: client_id,
        date: formattedDate,
      }
    });
    return response; // Return response to handle it in the component
  } catch (err) {
    throw err; // Re-throw the error to be caught in handleSubmit
  }
};

export const esg_smart_meter_max_demand = async (client_id, formattedDate) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/esg-smart-meter-max-demand/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: client_id,
        date: formattedDate,
      }
    });
    return response; // Return response to handle it in the component
  } catch (err) {
    throw err; // Re-throw the error to be caught in handleSubmit
  }
};


export const average_weekday_weekend_curve = async (client_id, formattedDate) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/average-weekday-weekend-curve/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: client_id,
        date: formattedDate,
      }
    });
    return response; // Return response to handle it in the component
  } catch (err) {
    throw err; // Re-throw the error to be caught in handleSubmit
  }
};


export const co2_emmission = async (client_id, formattedDate) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/co2-emmission/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: client_id,
        date: formattedDate,
      }
    });
    return response; // Return response to handle it in the component
  } catch (err) {
    throw err; // Re-throw the error to be caught in handleSubmit
  }
};

export const getGHGRows = async (site_id, selectedDate) => {
  try {
    const token = sessionStorage.getItem("accessToken");
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/get-ghg/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: { site_id, month: selectedDate },
    });
    return response;
  } catch (err) {
    throw err;
  }
};

export const createGHGRows = async (rows) => {
  try {
    const token = sessionStorage.getItem("accessToken");
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/get-ghg/`, rows, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  } catch (err) {
    throw err;
  }
};

export const updateGHGRow = async (id, data) => {
  try {
    const token = sessionStorage.getItem("accessToken");
    const response = await axios.patch(`${process.env.REACT_APP_API_URL}/api/get-ghg/`, data, {
      headers: { Authorization: `Bearer ${token}` },
      params: { id },
    });
    return response;
  } catch (err) {
    throw err;
  }
};

export const deleteGHGRow = async (id) => {
  try {
    const token = sessionStorage.getItem("accessToken");
    const response = await axios.delete(`${process.env.REACT_APP_API_URL}/api/get-ghg/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: { id },
    });
    return response;
  } catch (err) {
    throw err;
  }
};

export const readEmissionRate = async (siteId, date) => {
  try {
    const token = sessionStorage.getItem("accessToken");
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/reading-er/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: { site_id: siteId, date },
    });
    return response;
  } catch (err) {
    throw err;
  }
};

export const storeEmissionRate = async (siteId, date, er) => {
  try {
    const token = sessionStorage.getItem("accessToken");
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/storing-er/`, null, {
      headers: { Authorization: `Bearer ${token}` },
      params: { site_id: siteId, date, er },
    });
    return response;
  } catch (err) {
    throw err;
  }
};


export const getGHGScope2 = async (site_id, selectedDate) => {
  try {
    const token = sessionStorage.getItem("accessToken");
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/get-ghg-scope-2/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: { site_id, month: selectedDate },
    });
    return response;
  } catch (err) {
    throw err;
  }
};

export const harmonics_voltage = async (client_id, formattedDate, timeInterval) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/harmonics-voltage/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: client_id,
        date: formattedDate,
        interval: timeInterval
      }
    });
    return response; // Return response to handle it in the component
  } catch (error) {
    return null;
  }
};

export const harmonics_current = async (client_id, formattedDate, timeInterval) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/harmonics-current/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: client_id,
        date: formattedDate,
        interval: timeInterval
      }
    });
    return response; // Return response to handle it in the component
  } catch (error) {
    return null;
  }
};

export const harmonics_voltage_solar = async (client_id, formattedDate, timeInterval) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/harmonics-voltage-solar/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: client_id,
        date: formattedDate,
        interval: timeInterval
      }
    });
    return response; // Return response to handle it in the component
  } catch (error) {
    return null;
  }
};

export const harmonics_current_solar = async (client_id, formattedDate, timeInterval) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/harmonics-current-solar/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: client_id,
        date: formattedDate,
        interval: timeInterval
      }
    });
    return response; // Return response to handle it in the component
  } catch (error) {
    return null;
  }
};

export const harmonics_voltage_others = async (client_id, formattedDate, timeInterval) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/harmonics-voltage-others/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: client_id,
        date: formattedDate,
        interval: timeInterval
      }
    });
    return response; // Return response to handle it in the component
  } catch (error) {
    return null;
  }
};

export const harmonics_current_others = async (client_id, formattedDate, timeInterval) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/harmonics-current-others/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: client_id,
        date: formattedDate,
        interval: timeInterval
      }
    });
    return response; // Return response to handle it in the component
  } catch (error) {
    return null;
  }
};